import React from 'react'

const ApplySectionWrapperContainer = ({ children }) => (
  <div className="sm-apply__offer-details">
    <div className="col-first xs-second p24 bbs">{children}</div>
  </div>
)
export default ApplySectionWrapperContainer
